<template>
  <div class="hero-static">
    <div class="content reset-footer">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-6">
          <div class="block block-themed block-fx-shadow mb-0">
            <div class="block-header">
              <h3 class="block-title">Set New Password</h3>
              <div class="block-options">
                <router-link class="btn-block-option js-tooltip-enabled" to="/login" title="Sign In">
                  <i class="fa fa-sign-in-alt"></i>
                </router-link>
              </div>
            </div>
            <div class="block-content">
              <p v-if="message">{{ message }}</p>
              <p v-if="message">Click <router-link to="/forgot" title="Reset password">here</router-link> to reset your password.</p>
              <div class="reset-content" v-if="formStatus">
                <h1 class="mb-2">GrowTracker</h1>
                <p v-if="userEmail">E-mail address: {{ userEmail }}</p>
                <p>Please enter your desired password and repeat it to confirm.</p>
                <alert-message></alert-message>
                <form method="POST" name="reset-password" v-on:submit.prevent>
                <div class="form-group  reset-password">
                  <label>Password (at least 8 characters)</label>
                  <span class="input-field">
                    <input type="password" id="password" class="form-control form-control-lg form-control-alt" v-model="password" name="password" placeholder="Password" v-validate="'required|min:8|verify_password'" ref="password" data-vv-as="Password" autocomplete="new-password">
                    <span id="show-password" @click="changePassWordInputType('password', 'show-password')" class="fa fa-eye"></span>
                  </span>
                  <p class="password-complexity">
                    Password complexity: Make sure it's more than 15 characters OR at least 8 characters including a number, a lowercase letter, an uppercase letter and a special character. (Eg: xxY98*zz)
                  </p>
                  <p v-if="errors.has('password')">{{ errors.first('password') }}</p>
                </div>
                <div class="form-group reset-password">
                  <label>Confirm Password</label>
                  <span class="input-field">
                    <input type="password" id="confirm-password" class="form-control form-control-lg form-control-alt" v-model="confirmPassword" name="confirmPassword" placeholder="Confirm Password" v-validate="{required: true, is: password}" data-vv-as="Confirm Password" autocomplete="new-password">
                    <span id="show-confirm-password" @click="changePassWordInputType('confirm-password', 'show-confirm-password')" class="fa fa-eye"></span>
                  </span>
                  <p v-if="errors.has('confirmPassword') && password">The password does not match.</p>
                  <p v-else-if="!password && errors.has('password')">The Password field is required.</p>
                </div>
                <div class="form-group">
                <div class="row">
                  <div class="col-12 col-md-6 col-xl-6 button-loader">
                    <button type="submit" v-bind:disabled="showLoader" class="btn btn-block btn-primary reset-button" @click="resetPassword()">
                      <div><span>Set new password</span></div>
                      <span v-if="showLoader" class="modal-loader">
                        <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="20" sizeUnit="px"></hash-loader>
                      </span>
                    </button>
                  </div>
                  <div class="col-12 col-md-6 col-xl-6">
                    <button type="submit" class="btn btn-block btn-primary reset-button">
                      Back to login
                    </button>
                  </div>
                </div>
                </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions } from 'vuex';
import VeeValidate from 'vee-validate';
import Footer from '@/components/Footer';
import AlertMessage from '@/components/AlertMessage';
import { VueSpinners } from '@saeris/vue-spinners';
import { HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';
import base64 from 'base-64';
import utf8 from 'utf8';
Vue.use(VeeValidate, base64, VueSpinners);

VeeValidate.Validator.extend('verify_password', {
  getMessage: field => 'Please give a valid password according to the password complexity.',
  validate: value => {
    var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$&+,:;=?@#\|\'<>.^*()%!-/}{~`_\\\\])');
    return strongRegex.test(value);
  }
});

export default {
  name: 'ResetPassword',
  components: {
    Footer,
    AlertMessage,
    HashLoader
  },
  data : () => ({
    password: '',
    confirmPassword: '',
    formStatus: false,
    message: '',
    userEmail: '',
    showLoader: false
  }),
  mounted() {
    let vm = this;
    helper.sendPostRequest('/login/verify',
      {'key': vm.$route.params.key},
      { headers: vm.getAuthHeader() })
      .then(function(data) {
        if (data.status === 'success') {
          vm.formStatus = true;
          vm.userEmail = data.email;
        } else {
          vm.message = data.message;
        }
      }).catch(function(){
        vm.message = 'Unable to process your request.';
      });
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    resetPassword() {
      let vm = this;
      this.$validator.validate().then(valid => {
        if (valid) {
          vm.showLoader = true;
          helper.sendPostRequest('/login/resetpassword', {
            'email': vm.userEmail,
            'password': base64.encode(utf8.encode(vm.password)),
            'confirmPassword': base64.encode(utf8.encode(vm.confirmPassword))
          }, { headers: vm.getAuthHeader() })
            .then(function(data) {
              if (data.status === 'success') {
                vm.success(data.message);
                vm.$router.push('/login');
              } else {
                vm.error(data.message);
                vm.password = '';
                vm.confirmPassword = '';
              }
              vm.showLoader = false;
              vm.handleAlertMessage();
            }).catch(function() {
              vm.showLoader = false;
              vm.password = '';
              vm.confirmPassword = '';
              vm.error('Please enter the valid password.');
              vm.handleAlertMessage();
            });
        }
      });
    },
    changePassWordInputType(input, icon) {
      let inputType = this.$el.querySelector('#' + input).type;
      if (inputType === 'password') {
        this.$el.querySelector('#' + icon).classList.remove('fa-eye');
        this.$el.querySelector('#' + icon).classList.add('fa-eye-slash');
        this.$el.querySelector('#' + input).type = 'text';
      } else {
        this.$el.querySelector('#' + icon).classList.remove('fa-eye-slash');
        this.$el.querySelector('#' + icon).classList.add('fa-eye');
        this.$el.querySelector('#' + input).type = 'password';
      }
    },
    handleAlertMessage() {
      let vm = this;
      setTimeout(() => { vm.clear(); }, 5000);
    }
  }
};
</script>

<style>
.reset-content {
  padding: 1rem;
}
.reset-footer {
  min-height: calc(100vh - 61px);
  padding-bottom: 2rem;
}
.reset-button {
  margin-top: 17px;
}
.reset-password #show-password,
.reset-password #show-confirm-password {
  position: absolute;
  top: 16px;
  right: 15px;
}
.password-complexity {
  line-height: 16px;
  color: #575757 !important;
}
.reset-password p {
  color: red;
  font-size: 0.7rem;
  margin-bottom: 0 !important;
  padding-top: 5px;
}
.input-field, #confirm-password {
  position: relative;
  width: 100%;
  display: inline-block;
}
.reset-content > p {
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// source/components/ResetPassword.vue